import type { PortalSession } from "@/lib/api";

export type NavigationRole = PortalSession["role"] | "guest";

export interface NavigationTab {
  id: string;
  label: string;
  to: string;
  match: {
    hashes?: string[];
    paths: string[];
  };
}

const NAVIGATION_TABS: Record<NavigationRole, NavigationTab[]> = {
  guest: [],
  candidate: [
    {
      id: "candidate-dashboard",
      label: "Dashboard",
      to: "/candidate",
      match: {
        paths: ["/candidate"]
      }
    },
    {
      id: "candidate-internship",
      label: "Internship",
      to: "/candidate/internship",
      match: {
        paths: ["/candidate/internship"]
      }
    },
    {
      id: "candidate-addendum",
      label: "Addendum",
      to: "/candidate/addendum",
      match: {
        paths: ["/candidate/addendum"]
      }
    }
  ],
  admin: [
    {
      id: "admin-dashboard",
      label: "Dashboard",
      to: "/admin",
      match: {
        paths: ["/admin"]
      }
    },
    {
      id: "admin-users",
      label: "Users",
      to: "/admin/users",
      match: {
        paths: ["/admin/users", "/admin/pending-users"]
      }
    },
    {
      id: "admin-verified-approvals",
      label: "Verified Approvals",
      to: "/admin/verified-approvals",
      match: {
        paths: ["/admin/verified-approvals"]
      }
    },
    {
      id: "admin-pending-agreements",
      label: "Agreements",
      to: "/admin/pending-agreements",
      match: {
        paths: ["/admin/pending-agreements"]
      }
    },
    {
      id: "admin-all-forms",
      label: "All Forms",
      to: "/admin/all-forms",
      match: {
        paths: ["/admin/all-forms"]
      }
    },
    {
      id: "admin-saved-drafts",
      label: "Saved Drafts",
      to: "/admin/saved-drafts",
      match: {
        paths: ["/admin/saved-drafts"]
      }
    },
    {
      id: "admin-create-form",
      label: "Create Form",
      to: "/admin/create-form",
      match: {
        paths: ["/admin/create-form"]
      }
    },
    {
      id: "admin-edit-form",
      label: "Edit Form",
      to: "/admin/edit-form",
      match: {
        paths: ["/admin/edit-form"]
      }
    }
  ]
};

export function getNavigationRole(session: PortalSession | null): NavigationRole {
  return session?.role ?? "guest";
}

export function getNavigationTabs(role: NavigationRole) {
  return NAVIGATION_TABS[role];
}

export function isNavigationTabActive(
  tab: NavigationTab,
  location: {
    hash: string;
    pathname: string;
  }
) {
  if (!tab.match.paths.includes(location.pathname)) {
    return false;
  }

  if (!tab.match.hashes) {
    return true;
  }

  return tab.match.hashes.includes(location.hash || "");
}
